export default __webpack_public_path__ + "static/media/team-3.b0f010e8.jpg";